import React, { useState } from "react";

const TopCoinBanyUnit = (props) => {
  const [activeAccordion, setActiveAccordion] = useState("collapse_1");

  const toggleAccordion = (accordionId) => {
    setActiveAccordion(accordionId === activeAccordion ? "" : accordionId);
  };

  // Array of FAQ questions
  const faqQuestions = [
    {
      question: "How Mini TopCoin Works",
      answer: (
        <div>
          <p className="mb-2">TopCoin UK customers can collect TopCoin when shopping with participating businesses.</p>
          <p className="mb-2">Each participating business sets its own <strong>TopCoin reward rate</strong>. When a qualifying purchase does not result in a whole number of TopCoin, the remaining reward is recorded as <strong>Mini TopCoin (M.T)</strong>.</p>
          <div className="p-3 bg-light text-center border mb-3 fw-bold">
            50 Mini TopCoin = 1 TopCoin
          </div>
          <p className="mb-2">Mini TopCoin automatically accumulate in your account. Each time you reach 50 Mini TopCoin, they automatically convert into 1 full TopCoin.</p>
          <p className="mb-0">TopCoin and Mini TopCoin are loyalty reward units within the TopCoin UK platform. They are not money, investments or financial products.</p>
        </div>
      ),
    },
    {
      question: "What Is a Mini TopCoin?",
      answer: (
        <div>
          <p className="mb-2">A Mini TopCoin represents a fraction of one full TopCoin.</p>
          <p className="mb-3 fw-bold">1 Mini TopCoin = 1/50 of a TopCoin</p>
          <div className="table-responsive mb-3">
            <table className="table table-bordered">
              <thead className="bg-light">
                <tr>
                  <th>Mini TopCoin</th>
                  <th>Equivalent</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>25 M.T</td>
                  <td>1/2 TopCoin</td>
                </tr>
                <tr>
                  <td>50 M.T</td>
                  <td>1 TopCoin</td>
                </tr>
                <tr>
                  <td>75 M.T</td>
                  <td>1 TopCoin + 25 M.T</td>
                </tr>
                <tr>
                  <td>100 M.T</td>
                  <td>2 TopCoin</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mb-0">Any Mini TopCoin remaining after conversion stay in your account and continue building towards your next full TopCoin.</p>
        </div>
      ),
    },
    {
      question: "Automatic Conversion",
      answer: (
        <div>
          <p className="mb-2">When your Mini TopCoin balance reaches <strong>50</strong>, the platform automatically converts them into <strong>1 full TopCoin</strong>.</p>
          <p className="mb-3">
            Example: You have <strong>48 Mini TopCoin</strong> and your next qualifying purchase gives you <strong>7 Mini TopCoin</strong>. Your total becomes <strong>55 Mini TopCoin</strong>. The platform converts 50 Mini TopCoin into 1 TopCoin, leaving <strong>5 Mini TopCoin</strong> in your balance.
          </p>
          <div className="p-3 bg-light text-center border mb-0 fw-bold">
            Result: 1 TopCoin + 5 Mini TopCoin remaining
          </div>
        </div>
      ),
    },
    {
      question: "Why Mini TopCoin Are Useful",
      answer: (
        <div>
          <p className="mb-2">Mini TopCoin allow smaller qualifying purchases and partial TopCoin rewards to continue contributing towards your loyalty balance.</p>
          <p className="mb-2">This means customers do not lose the remaining part of a TopCoin reward when a purchase does not produce a whole TopCoin.</p>
          <p className="mb-0">Your Mini TopCoin continue accumulating automatically until you reach the next <strong>50 Mini TopCoin = 1 TopCoin</strong> conversion.</p>
        </div>
      ),
    },
    {
      question: "How Different Shop Reward Rates Work",
      answer: (
        <div>
          <p className="mb-4">Each participating business can set its own TopCoin reward rate. The Mini TopCoin calculation is therefore based on that particular shop's TopCoin rate.</p>
          
          <h6 className="fw-semibold text-dark opacity-75 mb-2">Example - Shop A</h6>
          <p className="mb-2 fw-bold">Reward rate: 1 TopCoin for every 50p spent</p>
          <p className="mb-3">Because 50 Mini TopCoin = 1 TopCoin, each 1p towards this 50p reward represents 1 Mini TopCoin.</p>
          <div className="table-responsive mb-4">
            <table className="table table-bordered">
              <thead className="bg-light">
                <tr>
                  <th>Spend</th>
                  <th>Reward</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>50p</td>
                  <td>1 TopCoin</td>
                </tr>
                <tr>
                  <td>75p</td>
                  <td>1 TopCoin + 25 Mini TopCoin</td>
                </tr>
                <tr>
                  <td>99p</td>
                  <td>1 TopCoin + 49 Mini TopCoin</td>
                </tr>
                <tr>
                  <td>£1.00</td>
                  <td>2 TopCoin</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h6 className="fw-semibold text-dark opacity-75 mb-2">Example - Shop B</h6>
          <p className="mb-2 fw-bold">Reward rate: 1 TopCoin for every £2 spent</p>
          <p className="mb-3">£2 = 200p. Dividing the £2 qualifying amount into 50 Mini TopCoin units means each Mini TopCoin represents 4p of progress towards the next TopCoin at this shop.</p>
          <div className="table-responsive mb-0">
            <table className="table table-bordered">
              <thead className="bg-light">
                <tr>
                  <th>Spend</th>
                  <th>Reward</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>£2.00</td>
                  <td>1 TopCoin</td>
                </tr>
                <tr>
                  <td>£2.40</td>
                  <td>1 TopCoin + 10 Mini TopCoin</td>
                </tr>
                <tr>
                  <td>£3.00</td>
                  <td>1 TopCoin + 25 Mini TopCoin</td>
                </tr>
                <tr>
                  <td>£3.96</td>
                  <td>1 TopCoin + 49 Mini TopCoin</td>
                </tr>
                <tr>
                  <td>£4.00</td>
                  <td>2 TopCoin</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      ),
    },
    {
      question: "Simple Explanation for Customers",
      answer: (
        <div>
          <p className="mb-2">Each participating business sets its own TopCoin reward rate.</p>
          <p className="mb-2">Whole TopCoin are awarded when the applicable reward threshold is reached.</p>
          <p className="mb-3">Any qualifying remainder is calculated as <strong>Mini TopCoin</strong> based on that business's reward rate.</p>
          <div className="p-3 bg-light text-center border mb-3 fw-bold">
            50 Mini TopCoin = 1 TopCoin
          </div>
          <p className="mb-2">Mini TopCoin automatically accumulate and convert into full TopCoin.</p>
          <p className="mb-0">TopCoin and Mini TopCoin are loyalty reward units used within the TopCoin UK programme.</p>
        </div>
      ),
    },
  ];

  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        
        <div className="row justify-content-center mb-5">
            <div className="col-12 text-center">
                <h2 className="title_text text-dark mb-2">MINI TOPCOIN (M.T)</h2>
                <h5 className="text-dark opacity-75">TopCoin UK Customer Guide</h5>
            </div>
        </div>

        <div
          className="tab_block"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-delay="100"
        >
          <div className="tab-content">
            {/* General Question Tab */}
            <div className="ico_accordion" id="accordion_1">
              {faqQuestions.map((item, index) => {
                const collapseId = `collapse_${index + 1}`;
                return (
                  <div className="accordion-item" key={collapseId}>
                    <div
                      className={`icon_arrow ${
                        activeAccordion === collapseId ? "collapsed" : ""
                      }`}
                      role="button"
                      onClick={() => toggleAccordion(collapseId)}
                    >
                      <svg
                        viewBox="0 0 23 27"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M10 14.597L10 2.56731C10 1.56579 10.8115 0.753906 11.8125 0.753906C12.8134 0.753906 13.6249 1.56579 13.6249 2.56731L13.6249 14.597C13.6249 15.5985 12.8134 16.4104 11.8125 16.4104C10.8115 16.4104 10 15.5985 10 14.597Z" />
                        <path d="M9.71371 25.8348L1.59744 17.7909C1.49009 17.6845 1.42969 17.5396 1.42969 17.3884L1.42969 14.2693C1.42969 13.7658 2.03695 13.5125 2.39443 13.8668L10.5108 21.9106C10.6181 22.017 10.6785 22.1619 10.6785 22.3131L10.6785 25.4323C10.6785 25.9358 10.0712 26.1891 9.71371 25.8348Z" />
                        <path d="M21.2273 13.8668L13.1111 21.9106C13.0037 22.017 12.9434 22.1619 12.9434 22.3131L12.9434 25.4323C12.9434 25.9358 13.5506 26.1891 13.9081 25.8348L22.0243 17.7909C22.1317 17.6845 22.1921 17.5396 22.1921 17.3884L22.1921 14.2693C22.1921 13.7658 21.5849 13.5125 21.2273 13.8668Z" />
                      </svg>
                    </div>
                    <div
                      className={`accordion-button ${
                        activeAccordion === collapseId ? "" : "collapsed"
                      }`}
                      role="button"
                      onClick={() => toggleAccordion(collapseId)}
                    >
                      <h5 className="fw-semibold text-dark m-0 ">
                        {" "}
                        {`${index + 1}- ${item.question}`}
                      </h5>
                    </div>
                    <div
                      id={collapseId}
                      className={`accordion-collapse collapse ${
                        activeAccordion === collapseId ? "show" : ""
                      }`}
                      data-bs-parent="#accordion_1"
                    >
                      <div className="accordion-body">
                        <div>{item.answer}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopCoinBanyUnit;
